import React from "react";
import { Radio } from "@assets/spa/control/radio";
export function ForminatorRadio(props) {
    const { onChange, value = [], options, } = props;
    return React.createElement(React.Fragment, null, options && options.length > 0 && options.map((opt) => {
        return React.createElement(Radio, { key: opt.key, label: opt.label, onChange: () => {
                onChange(opt.value);
            }, checked: value === opt.value });
    }));
}
